import { render, staticRenderFns } from "./feedback.vue?vue&type=template&id=2e42ab6a&scoped=true"
import script from "./feedback.vue?vue&type=script&lang=js"
export * from "./feedback.vue?vue&type=script&lang=js"
import style0 from "./feedback.vue?vue&type=style&index=0&id=2e42ab6a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e42ab6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e42ab6a')) {
      api.createRecord('2e42ab6a', component.options)
    } else {
      api.reload('2e42ab6a', component.options)
    }
    module.hot.accept("./feedback.vue?vue&type=template&id=2e42ab6a&scoped=true", function () {
      api.rerender('2e42ab6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/supplySystem/statisticsManagement/statisticsSurvey/feedback.vue"
export default component.exports